import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "derm_cart_v1";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
    });

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(items));
    }, [items]);

    const add = (product, qty = 1) => {
        setItems((prev) => {
            const found = prev.find((i) => i.product_id === product.id);
            if (found) {
                return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
            }
            return [...prev, {
                product_id: product.id,
                name: product.name,
                sku: product.sku,
                price: product.price,
                image_path: product.image_path,
                quantity: qty,
            }];
        });
    };

    const setQty = (product_id, qty) => {
        if (qty <= 0) return remove(product_id);
        setItems((prev) => prev.map((i) => i.product_id === product_id ? { ...i, quantity: qty } : i));
    };
    const remove = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
    const clear = () => setItems([]);

    const totalQty = items.reduce((s, i) => s + i.quantity, 0);
    const totalPrice = items.reduce((s, i) => s + (i.price || 0) * i.quantity, 0);

    return (
        <CartContext.Provider value={{ items, add, setQty, remove, clear, totalQty, totalPrice }}>
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
